import React from 'react';
import { Counter, HelperStyled, HelperText, InputAdornment, InputStyled } from './Input.styles';
const Input = ({ disabled, helperText, label, required, counter, maxLength, leadingAdornment, trailingAdornment, error, ...props }) => {
    if (maxLength === 0) {
        console.warn('Input disabled; input maxLength set to 0.');
    }
    else if (counter && !maxLength) {
        console.warn('Not showing input counter; counter enabled, but maxLength is undefined.');
    }
    const [contentLength, setContentLength] = React.useState(0);
    const onChange = (event) => {
        setContentLength(event.currentTarget.value.length);
        props.onChange && props.onChange(event);
    };
    const [focused, setFocused] = React.useState(false);
    const onBlur = (event) => {
        setFocused(false);
        props.onBlur && props.onBlur(event);
    };
    const onFocus = (event) => {
        setFocused(true);
        props.onFocus && props.onFocus(event);
    };
    const showCounter = counter && !!maxLength;
    return (React.createElement(InputStyled, { disabled: disabled, label: label, helperText: (showCounter || helperText) &&
            React.createElement(HelperStyled, null,
                React.createElement(HelperText, null, helperText),
                showCounter &&
                    React.createElement(Counter, { focused: props.focused || focused },
                        contentLength,
                        " / ",
                        maxLength)), required: required, error: error, onChange: onChange, onFocus: onFocus, onBlur: onBlur, ...props, inputProps: {
            maxLength,
            ...props.inputProps,
        }, InputProps: {
            startAdornment: leadingAdornment &&
                React.createElement(InputAdornment, { position: "start" }, leadingAdornment),
            endAdornment: trailingAdornment &&
                React.createElement(InputAdornment, { position: "end" }, trailingAdornment),
        }, FormHelperTextProps: {
            style: {
                overflow: 'hidden',
                margin: 0,
                padding: '3px 14px 0px',
            },
        } }));
};
export default Input;
//# sourceMappingURL=Input.js.map